import { useLocation, useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";

import Weekdays from "../../Components/Weekdays/Weekdays";
import RenderActivities from "../../Components/RenderActivities/RenderActivities";
import "./style.scss";
import useApi from "../../hooks/useApi";
import { useEffect, useState } from "react";

const ConsumerSessionDetails = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { classID } = useParams();
  const { get } = useApi();

  const [classDetails, setClassDetails] = useState();

  const fetchDetails = async () => {
    try {
      const data = await get(`/Schedule/${classID}`);

      setClassDetails(data);
    } catch (err) {
      console.log(err);
    }
  };

  const convertDate = (value) => {
    const date = new Date(value);

    const day = date.getDate();
    const month = date.getMonth() + 1;

    const monthName = t(`months.${month}`);

    const formattedDate = `${day} ${monthName}`;

    return formattedDate;
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  return (
    <div className="consumer-session-details-container">
      {classDetails ? (
        <>
          <div className="session-weekdays-wrapper">
            {classDetails?.isOneTime ? (
              <h1>{convertDate(classDetails?.effectiveFrom)}</h1>
            ) : (
              <Weekdays weekdaysData={classDetails?.scheduleDays} />
            )}

            <div className="session-description">
              <RenderActivities activities={"tennis"} />
              <h4>{classDetails?.description}</h4>
            </div>
          </div>

          <div className="class-financial-details">
            <h4>{t("financial_section_header")}</h4>

            <ul>
              {classDetails?.isOneTime ? (
                <li>{t("details_onetime_event")}</li>
              ) : (
                <>
                  {classDetails?.groupSchedule ? (
                    <li>
                      {classDetails?.financialDetails?.payerOption ===
                      "Individual"
                        ? t("details_paymentType_individual")
                        : t("details_paymentType_onePay")}
                    </li>
                  ) : (
                    <li>{t("details_individual_schedule")}</li>
                  )}
                </>
              )}

              <li>
                {t("details_price", {
                  price: classDetails?.price,
                  period:
                    classDetails?.financialDetails?.pricingType === "Monthly"
                      ? `/ ${t("month")}`
                      : `/ ${t("day")}`,
                })}
              </li>
              <li>
                {t(
                  classDetails?.financialDetails?.billingPeriod ===
                    "End_Of_The_Month"
                    ? "details_billingType_end_of_month"
                    : classDetails?.financialDetails?.billingPeriod ===
                        "Beginning_of_the_Month"
                      ? "details_billingType_beginning_of_month"
                      : classDetails?.financialDetails?.paymentType ===
                          "PrePaid"
                        ? "details_billingType_based_on_events_prePaid"
                        : "details_billingType_based_on_events_postPaid",
                  {
                    count: classDetails?.financialDetails?.billingEventCount,
                  },
                )}
              </li>
              <li>
                {classDetails?.financialDetails?.paymentType === "PrePaid"
                  ? t(
                      classDetails?.groupSchedule
                        ? "details_paymentType_prePaid_group"
                        : "details_paymentType_prePaid_individual",
                      {
                        count:
                          classDetails?.financialDetails?.prepaymentEventCount,
                      },
                    )
                  : t(
                      classDetails?.groupSchedule
                        ? "details_paymentType_postPaid_group"
                        : "details_paymentType_postPaid_individual",
                    )}
              </li>
            </ul>
          </div>
          <div className="provider-info">
            <h3>{classDetails?.providerName}</h3>
            <span>{classDetails?.providerNumber}</span>
            <span>{classDetails?.providerEmail}</span>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default ConsumerSessionDetails;
